import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';

	interface main {
		ids ?: any,
		size ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
	}
export default /*#__PURE__*/_defineComponent({
  __name: 'AddressSelect',
  props: {
    ids: { default: [] },
    size: { default: "default" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false },
    IsAuto: { type: Boolean, default: false }
  },
  emits: ["update:ids", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

	;

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	const options = ref([]);
	const optionProps = ref({
		value: "id",
		label: "name",
		children: "children",
	});
	const AddressIdArr = ref<any>([]);
	const loading = ref(false);
	const placeholder = ref("请选择地区");

	watch(() => props.ids, (n : any) => {
		AddressIdArr.value = n;
	});

	onMounted(() => {
		AddressIdArr.value = props.ids;
		if (props.IsAuto) {
			if (proxy.$store.state.AddressList.length > 0) {
				options.value = proxy.$store.state.AddressList;
			} else {
				loading.value = true;
				proxy.$api.tokenRequest({
					url: '/admin/region',
					success: (res : any) => {
						loading.value = false;
						options.value = res.data;
						proxy.$store.commit("GetAllList", {
							type: 3,
							data: res.data,
						});
					},
					fail: () => {
						loading.value = false;
					}
				});
			}
		}
	});

	const AddressChange = (data : any) => {
		emits("update:ids", data);
		emits("change", data);
	};
	const AddressClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (options.value.length == 0 && !props.IsAuto) {
			if (proxy.$store.state.AddressList.length > 0) {
				options.value = proxy.$store.state.AddressList;
			} else {
				proxy.$api.tokenRequest({
					url: '/admin/region',
					data: {
						type: 1,
					},
					success: (res : any) => {
						loading.value = false;
						options.value = res.data;
						proxy.$store.commit("GetAllList", {
							type: 3,
							data: res.data,
						});
					},
					fail: () => {
						loading.value = false;
					}
				});
			}
		}
	};

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createBlock(_component_el_cascader, {
    size: _ctx.size,
    style: _normalizeStyle({'width': `${_ctx.width}`}),
    modelValue: AddressIdArr.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((AddressIdArr).value = $event)),
    options: options.value,
    props: optionProps.value,
    separator: "，",
    placeholder: placeholder.value,
    clearable: "",
    filterable: "",
    onFocus: SelectFocus,
    onClear: AddressClear,
    onChange: AddressChange
  }, null, 8, ["size", "style", "modelValue", "options", "props", "placeholder"]))
}
}

})